<template>
  <div>
    <div class="form-container ou-donation-form teach-donation-form">
      <div class="holder">
        <div></div>
        <PaymentForm class="form-horizontal">
          <FormSection title="">
            <AmountSelector />
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <PaymentOptions onlyMonthly />
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol :simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
            <br />
            <InHonorOf />
            <br />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" class="teachpay" />
        </PaymentForm>
        <div class="footer-copyright">
          NCSY is a project of the Orthodox Union, is a 501(c)(3), EIN:
          13-5623717.<br />
          All donations to NCSY are tax-deductible to the full extent permitted by
          law.
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  components: {},
  setup(props) {
    const { form, setValue } = usePaymentForm();

    return {
      form,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.donate-intro {
  font-size: 18px;
  line-height: 26px;
  color: #00346b;
  p {
    margin-bottom: 10px;
  }
  a {
    color: #00346b;
    font-weight: 600;
  }
}

.form-container.ou-donation-form.teach-donation-form {
  max-width: 100%;
  box-shadow: none;
  padding: 0px;
  margin: 0px auto;
}
.teach-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: space-between;

  label {
    border: 1px solid #0d346c;
    color: #000000;
    font-size: 15px;
    &:hover {
      background: #f7f7f7;
    }
  }
  input[type="radio"]:checked + label {
    background: #0d346c;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0d346c;
    border-color: #0d346c;
  }
  .label-description {
    font-size: 16px;
  }
  .label-amount {
    background: #0d346c;
    color: white;
  }
  .radio-part {
    min-width: 23%;
    max-width: 23%;
  }
}

.teach-donation-form
  .frequency
  ::v-deep
  .styled-radio-container--ou-donation.styled-radio-container {
  .radio-part {
    min-width: 33%;
    max-width: 33%;
  }
}
.teach-donation-form .payment-info ::v-deep .styled-radio-container--ou-donation {
  .radio-part {
    min-width: 50%;
    max-width: 50%;
  }
}
.footer-links {
  text-align: center;
  font-size: 16px;
  margin: 50px auto 28px;
  line-height: 26px;
  color: #00346b;
  a {
    text-decoration: none;
  }
}
.footer-copyright {
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  color: #222;
  font-style: italic;
}

.payment {
  margin: 20px auto 20px;
  ::v-deep .ou-donation-btn {
    width: 300px;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
}
.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}

.doublepay {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep h2 {
  &:not(:empty) {
    font-weight: 700;
    border-bottom: 1px solid #ccc;
    padding: 0 16px 8px 0;
    margin: 28px 0 28px 0;
    font-size: 1.25em;
  }
}

.teach-donation-form ::v-deep .styled-radio--ou-donation.styled-radio {
  gap: 0px 10px;
  .radio-part {
    min-width: calc(33% - 10px);
    line-height: 20px;
    max-width: calc(33% - 10px);
    padding-right: 0px;
    padding-left: 0px;
  }
}
.teach-donation-form ::v-deep .oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation .amount_other__wrapper {
  background: white;
}
</style>
